var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconContacts01 = function SvgIconContacts01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_contacts-01_svg2__a",
    x1: 24.58,
    x2: 91.22,
    y1: -18.82,
    y2: 81.98,
    gradientTransform: "matrix(1 0 0 -1 0 102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_contacts-01_svg2__a",
    id: "icon_contacts-01_svg2__b",
    x1: 28.26,
    x2: 94.89,
    y1: -21.25,
    y2: 79.55
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_contacts-01_svg2__a",
    id: "icon_contacts-01_svg2__c",
    x1: 12.55,
    x2: 79.18,
    y1: -10.83,
    y2: 89.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#icon_contacts-01_svg2__a",
    id: "icon_contacts-01_svg2__d",
    x1: 11.97,
    x2: 78.55,
    y1: -10.49,
    y2: 90.22
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M74.25 66.03H45.43a1.451 1.451 0 0 0 0 2.9h28.82a1.451 1.451 0 0 0 0-2.9",
    style: {
      fill: "url(#icon_contacts-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.25 74.03H45.43a1.451 1.451 0 0 0 0 2.9h28.82a1.451 1.451 0 0 0 0-2.9",
    style: {
      fill: "url(#icon_contacts-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.75 28.47c0-3.05-2.5-5.54-5.54-5.54H49.53c-3.05 0-5.54 2.5-5.54 5.54v1.3a1.451 1.451 0 0 0 2.9 0v-1.3c0-1.45 1.15-2.6 2.6-2.6h20.68c1.45 0 2.6 1.15 2.6 2.6v21.48A17.1 17.1 0 0 0 66.18 45c1-1.3 1.6-2.95 1.6-4.75 0-4.4-3.55-7.94-7.94-7.94s-7.94 3.55-7.94 7.94.6 3.4 1.6 4.75c-2.6 1.05-4.85 2.8-6.59 4.95V36.56a1.451 1.451 0 0 0-2.9 0v17.53c0 3.05 2.5 5.54 5.54 5.54h20.68c3.05 0 5.54-2.5 5.54-5.54V28.42v.05Zm-15.88 6.79c2.75 0 5 2.25 5 5s-2.25 5-5 5-5-2.25-5-5 2.25-5 5-5M70.2 56.69H49.52c-1.05 0-1.9-.6-2.35-1.5 1.6-3.9 4.85-6.84 8.89-8.04 1.15.65 2.45 1 3.8 1s2.7-.35 3.8-1c4.05 1.15 7.29 4.1 8.89 8.04-.4.85-1.3 1.5-2.35 1.5",
    style: {
      fill: "url(#icon_contacts-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.89 82.62c.8 0 1.45-.65 1.45-1.45V5.59c0-3.1-2.5-5.59-5.59-5.59h-64.3c-3.1 0-5.59 2.5-5.59 5.59v4.8h-2.25c-2.75 0-4.95 2.2-4.95 4.95s2.2 4.95 4.95 4.95h2.25v7.44h-2.25c-2.75 0-4.95 2.2-4.95 4.95s2.2 4.95 4.95 4.95h2.25v7.44h-2.25c-2.75 0-4.95 2.2-4.95 4.95s2.2 4.95 4.95 4.95h2.25v7.44h-2.25c-2.75 0-4.95 2.2-4.95 4.95s2.2 4.95 4.95 4.95h2.25v7.44h-2.25c-2.75 0-4.95 2.2-4.95 4.95s2.2 4.95 4.95 4.95h2.25v4.8c0 3.1 2.5 5.59 5.59 5.59h64.29c3.1 0 5.59-2.5 5.59-5.59v-6.29a1.451 1.451 0 0 0-2.9 0v6.29c0 1.5-1.2 2.7-2.7 2.7H33.68V2.95h52.05c1.5 0 2.7 1.2 2.7 2.7v75.52c0 .8.65 1.45 1.45 1.45ZM11.61 15.33c0-1.1.9-2 2-2H21c1.1 0 2 .9 2 2s-.9 2-2 2h-7.39c-1.1 0-2-.9-2-2m0 17.29c0-1.1.9-2 2-2H21c1.1 0 2 .9 2 2s-.9 2-2 2h-7.39c-1.1 0-2-.9-2-2m0 17.33c0-1.1.9-2 2-2H21c1.1 0 2 .9 2 2s-.9 2-2 2h-7.39c-1.1 0-2-.9-2-2m0 17.33c0-1.1.9-2 2-2H21c1.1 0 2 .9 2 2s-.9 2-2 2h-7.39c-1.1 0-2-.9-2-2m0 17.29c0-1.1.9-2 2-2H21c1.1 0 2 .9 2 2s-.9 2-2 2h-7.39c-1.1 0-2-.9-2-2m19.18 12.38h-9.34c-1.5 0-2.7-1.2-2.7-2.7v-4.8H21c2.75 0 4.95-2.2 4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-7.44H21c2.75 0 4.95-2.2 4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-7.44H21c2.75 0 4.95-2.2 4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-7.44H21c2.75 0 4.95-2.2 4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-7.44H21c2.75 0 4.95-2.2 4.95-4.95s-2.2-4.95-4.95-4.95h-2.25v-4.8c0-1.5 1.2-2.7 2.7-2.7h9.34V96.9Z",
    style: {
      fill: "url(#icon_contacts-01_svg2__d)"
    }
  }));
};
export default SvgIconContacts01;